import { useGenericGet } from './use-api.hook';
import { apiClient } from '../services/api-client.service';
import type { UserGetResponse } from '../components/dashboard/admin/users/types/user.types';

export const useMe = (queryOptions?: any) => {
  return useGenericGet<UserGetResponse>('/v1/auth/me', ['Me'], apiClient, {
    // Cache successful responses for 5 minutes
    staleTime: 5 * 60 * 1000,
    // Keep the data in cache for 10 minutes
    gcTime: 10 * 60 * 1000,
    // Don't refetch on window focus
    refetchOnWindowFocus: false,
    // Don't refetch on component mount
    refetchOnMount: false,
    ...queryOptions,
  });
};
